import { mobileDevice } from '@bingads-webui-campaign-react/mca-core';

export const getStepFooterStyles = (_, { palette = {} }) => ({
  footerContainer: {
    width: '100%',
    display: 'flex',
    clear: 'both',
    borderTop: `1px solid ${palette.neutralLight}`,
    paddingLeft: '32px',
    paddingTop: '15px',
    paddingBottom: '17px',
    background: palette.white,
    [mobileDevice]: {
      flexWrap: 'wrap',
    },
  },
  previousButton: {
    marginRight: '8px',
  },
  // For primary button border none in high contrast mode in edge
  primaryButton: {
    '&:focus::after': {
      '@media screen and (-ms-high-contrast: active)': {
        border: '1px solid white !important',
      },
    },
  },
  cancelButton: {
    marginLeft: '32px',
  },
  skippingLink: {
    marginLeft: '24px',
  },
  errorMessage: {
    color: palette.red,
    marginLeft: '16px',
    marginRight: '230px',
    alignItems: 'center',
    display: 'flex',
    [mobileDevice]: {
      margin: '8px 24px 0px 0px',
    },
  },
});
